import React, { useContext } from 'react';

import { ResearchContext } from '../../ResearchContext';


import {
    Autocomplete,
    Grid,
    TextField
} from '@mui/material';
import { SearchType } from "../../../../../helpers";


export function DistrettualeFilter() {

    const {

        state,

        isLoadingDistretti,
        isLoadingCircondari,

        distrettoFilter,
        setDistrettoFilter,

        circondarioFilter,
        setCircondarioFilter,

        isLoadingFilterFromCookies,
        setIsLoadingFilterFromCookies,

        activeSearchType,

    } = useContext(ResearchContext);

    const {
        distrettiOptions,
        circondariOptions,
    } = state;

    return activeSearchType == SearchType.Distretto &&
        <Grid container>
            <Grid item md={6} xs={12} padding={1} >
                <Autocomplete
                    disabled={isLoadingDistretti}
                    fullWidth
                    options={distrettiOptions}
                    onChange={(e, value) => {
                        if (isLoadingFilterFromCookies) {
                            setIsLoadingFilterFromCookies(false);
                        }


                        setDistrettoFilter(value?.ufficioId ?? "");
                    }}
                    value={distrettiOptions.find(option => option.ufficioId == distrettoFilter) ?? null}
                    renderInput={(params) => <TextField fullWidth {...params} label="Distretto" placeholder='Seleziona il Distretto' />}
                />
            </Grid>
            <Grid item md={6} xs={12} padding={1}>
                <Autocomplete
                    disabled={isLoadingCircondari}
                    fullWidth
                    options={circondariOptions}
                    onChange={(e, value) => {
                        if (isLoadingFilterFromCookies) {
                            setIsLoadingFilterFromCookies(false);
                        }

                        setCircondarioFilter(value?.ufficioId ?? "");
                    }}
                    value={circondariOptions.find(option => option.ufficioId == circondarioFilter) ?? null}
                    renderInput={(params) => <TextField fullWidth {...params} label="Circondario" placeholder='Selezione il Circondario' />}
                />
            </Grid>
        </Grid>
}